import Vue from 'vue';
import startOfDay from 'date-fns/startOfDay';
import parseISO from 'date-fns/parseISO';
import isBefore from 'date-fns/isBefore';
import isEqual from 'date-fns/isEqual';
import isAfter from 'date-fns/isAfter';
import format from 'date-fns/format';
import { confirmed, email, max, min, required } from 'vee-validate/dist/rules';
import { extend, ValidationObserver, ValidationProvider } from 'vee-validate';
import VTextFieldWithValidation from '@/components/inputs/VTextFieldWithValidation';
import VSelectWithValidation from '@/components/inputs/VSelectWithValidation';
import VTextareaWithValidation from '@/components/inputs/VTextareaWithValidation';

extend('required', {
  ...required,
  message: 'This field is required'
});

extend('email', {
  ...email,
  message: 'This field must be a valid email'
});

extend('min', {
  ...min,
  message: 'This field must be {length} characters or more'
});

extend('max', {
  ...max,
  message: 'This field must be {length} characters or less'
});

extend('confirmed', {
  ...confirmed,
  message: 'The {_field_} field confirmation does not match'
});

extend('before_or_equal_today', {
  validate: (val, { date }) => {
    const today = startOfDay(new Date());
    return isBefore(date, today) || isEqual(date, today);
  },
  message: 'The field should before or equal today',
  params: [
    {
      name: 'date',
      cast(value) {
        return parseISO(value);
      },
    },
  ],
});

extend('after_date', {
  validate: (val, { date, target }) => {
    if (isAfter(date, target)) {
      return true;
    }
    const text = format(target, 'yyyy-MM-dd');
    return `The field should after ${text}`;
  },
  params: [
    {
      name: 'date',
      cast(value) {
        return parseISO(value);
      },
    },
    {
      name: 'target',
      cast(value) {
        return parseISO(value);
      },
    },
  ],
});

Vue.component('ValidationObserver', ValidationObserver);
Vue.component('ValidationProvider', ValidationProvider);
Vue.component('VTextFieldWithValidation', VTextFieldWithValidation);
Vue.component('VSelectWithValidation', VSelectWithValidation);
Vue.component('VTextareaWithValidation', VTextareaWithValidation);
